// Import necessary components from React and Material-UI
import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import { motion } from 'framer-motion';

const About = () => {
  return (
    // Box is a Material-UI component that acts like a div with styling
    // id="about" is used for navigation
    // py: 8 means padding on y-axis (top and bottom)
    // bgcolor: 'background.paper' sets a light background color
    <Box id="about" sx={{ py: 8, bgcolor: 'background.paper' }}>
      {/* Container centers content and sets max-width */}
      <Container>
        {/* Heading outside the Paper box */}
        <Typography
          variant="h2"
          gutterBottom
          sx={{ color: '#000', fontWeight: 'bold' }}
        >
          About Me
        </Typography>
        <Paper
          sx={{
            p: 3,
            borderRadius: 4, // More rounded corners (4 = 32px)
            backgroundColor: '#1976d2', // Soft blue background
            color: '#fff', // White text
            boxShadow: 3, // Subtle shadow
          }}
        >
          {/* motion.div adds animation effects */}
          <motion.div
            // Initial state: invisible and 20px below final position
            initial={{ opacity: 0, y: 20 }}
            // Final state: fully visible and in position
            animate={{ opacity: 1, y: 0 }}
            // Animation takes 0.5 seconds
            transition={{ duration: 0.5 }}
          >
            {/* paragraph adds margin below */}
            <Typography variant="body1" paragraph color="inherit">
             
            </Typography>
            <Typography variant="body1" color="inherit">
              Detailed Data scientists & analytics with background in statistics and data engineering well-versed in various statistical methods such as descriptive and influential statistics.
Independent and versatile individual skillful in identifying data issues and monitoring existing metrics. Offering 5 years of
experience collecting data, establishing facts and drawing valid conclusions. Proficient in SQL, R paired with first-rate report
writing abilities. Offering over 10 years of experience in managing environments, including recent work as data analyst.
Willing to take on any task to meet customer or business needs and dedicated to maximizing efficiency and business revenue.
Excellent work ethic, organized nature and skilled planning expertise
            </Typography>
          </motion.div>
        </Paper>
      </Container>
    </Box>
  );
};

export default About;